export default {
    avenir: `'Avenir Next', Verdana, Geneva, Tahoma, sans-serif`,
    dnvDisplay: `'DNV Display'`
};
